import React from 'react'
import { twMerge } from 'tailwind-merge'

interface HorizontalLineProps {
  className?: string
}

export const HorizontalLine = ({ className }: HorizontalLineProps) => {
  return (
    <div className={twMerge('mt-6 h-[1px] w-full bg-bgTertiary', className)} />
  )
}
